/*******************************************************
TRIGGERS LINK INSIDE NAVIGATION ITEM
This function catches clicks on navigation items that
contain a single link (instead of a dropdown). Most of the
time, the user will tap/click the link inside, but this
covers the padding around the link.
********************************************************/

export default function triggerItemLink(e) {
    const $link = $(e.currentTarget).find('.s-nav__link');
    if (!$link.length || $link.attr('target') === '_blank') { return; }

    window.location.href = $link.attr('href');
}
